import { createSlice } from '@reduxjs/toolkit'

export const chargerTableSlice = createSlice({
  name: "chargerTableList",
  initialState: {
    data: []
  },
  reducers: {
    fetchChargerTableList: (state, action) => {
      state.data = action.payload;
    },
    addChargerId: (state, actions) => {
      state.data = actions.payload
    },
    addFleetId: (state, actions) => {
      state.data = actions.payload
    }

  }
});

export const { fetchChargerTableList, addChargerId, addFleetId } = chargerTableSlice.actions

export const getChargerTableList = (state) => state?.chargerTableList?.data

export default chargerTableSlice.reducer